import Vue from 'vue';
import { createPopper } from '@popperjs/core';

if (window.Bus === undefined) {
    window.Bus = new Vue();
}

export default {
    bind(el, binding, vnode) {
        Vue.nextTick(() => {
            let popperInstance = null;
            const tooltip = document.getElementById(binding.value);
            const placement = el.hasAttribute('data-popper-placement') ? el.getAttribute('data-popper-placement') : 'left';

            function create() {
                popperInstance = createPopper(el, tooltip, {
                    placement: placement,
                });
            }

            function destroy() {
                if (popperInstance) {
                    popperInstance.destroy();
                    popperInstance = null;
                }
            }

            function show() {
                tooltip.style.display = 'block';
                tooltip.setAttribute('data-show', '');
                create();
            }

            function hide() {
                tooltip.style.display = 'none';
                tooltip.removeAttribute('data-show');
                destroy();
            }

            function handleDocumentClick(e) {
                if (
                    !tooltip ||
                    !el ||
                    elementContains(tooltip, e.target) ||
                    elementContains(el, e.target) ||
                    !popperInstance ||
                    elementContains(popperInstance, e.target)
                ) {
                    return;
                }
                hide();
            }

            function elementContains(elm, otherElm) {
                if (typeof elm.contains === 'function') {
                    return elm.contains(otherElm);
                }
                return false;
            }

            el.addEventListener('click', show);
            document.addEventListener('click', handleDocumentClick);

            tooltip.querySelectorAll('[data-close]').forEach((closeEl) => {
                closeEl.addEventListener('click', hide);
            });
        });
    },
};
